import React from 'react';

export default ({user}) => (
  <section className='scene__scene-header detailsScene__scene-header'>
    <div className='go-back-to-list-header-button' onClick={() => {user.goToList(false)}}>Back</div>
    <header>
      New Component Application
    </header>
  </section>
)



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/Application/New/Header.jsx